import { useCallback, useState } from "react"
import { Box, Heading, Text } from "@chakra-ui/react"

import ModalContainer from "#/shared/components/ModalContainer"
import { MezoModalProps } from "#/shared/types"

import StoreItemFeedbackSurvey from "./StoreItemFeedbackSurvey"

export default function StoreFeedbackModal({
  isOpen,
  onClose,
}: MezoModalProps) {
  const [surveyCompleted, setSurveyCompleted] = useState(false)

  const closeModalHandler = useCallback(() => {
    onClose()
    setSurveyCompleted(false)
  }, [onClose])

  return (
    <ModalContainer isOpen={isOpen} onClose={closeModalHandler}>
      <Box bg="primary.white.100" borderRadius="24px" overflow="hidden">
        <Box bg="#F0EBE5" p="60px 65px 24px" textAlign="center">
          <Heading variant="h3" mb="22px">
            Didn&apos;t see something
            <br />
            you like?
          </Heading>
          <Text variant="body">
            Tell us what you&apos;d like to spend your
            <br /> MUSD towards.
          </Text>
        </Box>

        <StoreItemFeedbackSurvey
          surveyCompleted={surveyCompleted}
          setSurveyCompleted={setSurveyCompleted}
        />
      </Box>
    </ModalContainer>
  )
}
